import { render } from "./AnnouncementSvg.vue?vue&type=template&id=2a6af97a"
const script = {}

import "./AnnouncementSvg.vue?vue&type=style&index=0&id=2a6af97a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__